import { core } from '@tock/coretypes';

export type DesiredTimeRange = { startDateTime: string; endDateTime: string };

export const getDesiredTimeRange = (timeRanges: core.IWaitlistDesiredDateTimeRange[]) => {
  const startDateTime = timeRanges?.[0]?.startDateTime;
  const endDateTime = timeRanges?.[0]?.endDateTime;

  if (!startDateTime || !endDateTime) {
    return undefined;
  }

  return { startDateTime, endDateTime };
};
